<template>
  <div id="test">
    <es-form :model="form" status-icon ref="ruleForm2" label-width="100px" class="demo-ruleForm">
      <es-form-item label="method">
        <es-select v-model="form.method" :placeholder="$t(`请选择`)">
          <es-option label="GET" value="GET"></es-option>
          <es-option label="POST" value="POST"></es-option>
          <es-option label="DELETE" value="DELETE"></es-option>
        </es-select>
      </es-form-item>
      <es-form-item label="params" prop="params">
        <es-input v-model="form.params" type="textarea" row="10"> </es-input>
      </es-form-item>
      <es-form-item label="url" prop="url"> <es-input v-model="form.url"></es-input> </es-form-item>

      <es-form-item>
        <es-button type="primary" @click="submitForm('ruleForm2')">{{ $t('提交') }}</es-button>
        <es-button variant="outline" @click="resetForm('ruleForm2')">{{ $t('重置') }}</es-button>
      </es-form-item>
    </es-form>
  </div>
</template>
<script>
//去除换行
function ClearBr(key) {
  key = key.replace(/<\/?.+?>/g, '')
  key = key.replace(/[\r\n]/g, '')
  return key
}
function trim(str) {
  return str.replace(/\s+/g, '')
}
export default {
  name: 'Test',
  data() {
    return {
      form: {
        params: '',
        url: '',
        method: 'GET',
      },
    }
  },
  mounted() {},
  methods: {
    submitForm() {
      let tempParams = {
        fee: 0,
        flowMap: {},
        gid: '',
        map: { 'ce91e918-a9b0-42d2-a353-cd8645e59ad8': 0.01 },
        type: 'PAY',
      }

      let params = trim(ClearBr(this.form.params))
      let tempObj = {
        method: this.form.method,
        url: this.form.url,
      }
      this.$ajax(tempObj, tempParams).then(res => {
        console.log(res)
      })
    },
    resetForm() {},
  },
}
</script>
<style lang="less" scoped>
#test {
  width: 1000px;
  height: 500px;
  margin-top: 100px;
  margin: 0 auto;
}
</style>
